import { useComputed, useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
function ConfirmationRemoveUtgModal({ show, handleCancel, handleSubmitModalDelete, selectedUtgsSignal }) {
  
    const deleteInputSignal = useSignal('')
    const disableDeleteSubmitComputed = useComputed(() => {
        return 'delete' != (deleteInputSignal.value ? deleteInputSignal.value.toLowerCase() : '')
    })
  
    return (
    <Modal show={show} onHide={handleCancel}>
        <Modal.Header closeButton>
            <Modal.Title>Remove Selected UTGs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <p>If you are sure you want to remove the {selectedUtgsSignal.value.length} selected UTG(s) from Command Center, please enter &apos;delete&apos; and click &quot;Delete&quot; to complete the process.</p>
            <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Control
                        type="text"
                        required
                            onInput={(e) => deleteInputSignal.value = e.target.value}
                        autoFocus
                    />
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={handleCancel}>
                Cancel
            </Button>
                <Button disabled={disableDeleteSubmitComputed.value} variant="danger" onClick={handleSubmitModalDelete}>
                Delete
            </Button>
        </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationRemoveUtgModal;

